import {Actions, url} from "../../client/Actions";


const utils = {
    isEquals: (f, v) => {
        return f === v;
    },
    isNonEmpty: (v) => {
        return (v == false && v !== "" || v && v !== "none" && v !== "") ? true : false;
    },
    isNonNull: (v) => {
        return (v && v !== "") ? true : false;
    },
    isNull: (v) => {
        return (v === null) ? true : false;
    },
    defaultUrl: () => {
        return url();
    },
    numberWithSpaces: (v) => {
        return v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    unique: (array) => {
        return [...new Set(array)];
    },
    equalsById: (obj1, obj2) => {
        return (!obj1 && !obj2) || obj1?.id === obj2?.id
    },
    openFile: (filePath) => {
        window.open(utils.defaultUrl() + filePath, "_blank", "width=1100,height=400px,resizable=1");
    },
    join: (values) => {
        return values.map(v => v + "").join("")
    },
    globalConfig: (key, callback) => {
        Actions.get("globalConfig", (configs) => {
            const result = configs.find(c => c.key === key)
            callback(result.value)
        })
    },
    loadCleaningValidDuration: (callback) => {
        utils.globalConfig("CLEANING_WARNING_DURATION", callback)
    },
    isToggled: () => {
        return localStorage.getItem('toggled') === "true";
    },
    truncateText: (text, wordLimit = 7) => {
        const words = text.split(" ");

        // Check if it's a single big word (no spaces)
        if (words.length === 1) {
            return text.length > wordLimit
                ? text.slice(0, wordLimit) + "..."
                : text;
        }

        // Truncate based on word limit
        return words.length > wordLimit
            ? words.slice(0, wordLimit).join(" ") + "..."
            : text;
    },
    hasAnyKey: (obj, keys) => {
        return keys.some(key => obj.hasOwnProperty(key))
    }, countMatchingKeys: (obj, keys) => {
        return keys.filter(key => obj.hasOwnProperty(key)).length;
    }


};


export default utils;
